const tokenPrefix = "Bearer ";
export default tokenPrefix;
